<template>
  <div>
    <div class="content-wizard">
      <div class="row">
        <div class="col-lg-12">
          <h3 class="font-bold">Questions de qualification</h3>

          <div class="row">
            <div class="col-lg-6">
              <div class="m-t">
                L'état du véhicule est-il inchangé ?
                &nbsp;<i class="fa fa-info-circle"
                         v-tooltip="{
                              content: 'Pas de nouveaux defaults de carrosserie, etc...',
                              placement: 'top-center',
                              classes: ['tooltip-white']
                            }"></i>
                <div class="pull-right response">
                  <div class="i-checks">
                    <label>
                      <input type="radio"
                             :value="true"
                             v-model="ownerQuestions.isStateUnchanged"> <i></i> Oui
                    </label>
                  </div>
                  <div class="i-checks m-l">
                    <label>
                      <input type="radio"
                             :value="false"
                             v-model="ownerQuestions.isStateUnchanged"> <i></i> Non
                    </label>
                  </div>
                </div>
                <div v-if="!ownerQuestions.isStateUnchanged"
                     class="form-group"
                     :class="{'has-error': errors.has('state_changes')}">
                  <label class="control-label">
                    <input type="text"
                           placeholder="Quels sont les changements ?"
                           class="form-control input-bottom"
                           name="state_changes"
                           v-validate="'required'"
                           v-model="ownerQuestions.stateUnchanged">
                  </label>
                </div>

              </div>
            </div>
            <div class="col-lg-6">
              <div class="m-t">
                <div class="col-lg-8" style="padding:0;">
                  Le contrôle technique date-t-il bien toujours de moins de 6 mois ?
                  <a @click="fetchDocument('vehicleInspection')"><small> (visualiser le CT déposé)</small></a>
                  &nbsp;<i class="fa fa-info-circle"
                           v-tooltip="{
                              content: 'Cette condition est nécessaire pour la vente d\'un véhicule d\'occasion',
                              placement: 'top-center',
                              classes: ['tooltip-white']
                            }"></i>
                </div>

                <div class="pull-right response">
                  <div class="i-checks">
                    <label>
                      <input type="radio"
                             :value="true"
                             v-model="ownerQuestions.isValidVehicleInspection"> Oui
                    </label>
                  </div>
                  <div class="i-checks m-l">
                    <label>
                      <input type="radio"
                             :value="false"
                             v-model="ownerQuestions.isValidVehicleInspection"> Non
                    </label>
                  </div>
                </div>
                <div v-if="!ownerQuestions.isValidVehicleInspection"
                     class="form-group"
                     :class="{'has-error': errors.has('vehicle_inspection_date')}">
                  <label class="control-label">
                    <input type="date"
                           placeholder="JJ/MM/AAAA"
                           name="vehicle_inspection_date"
                           class="form-control input-bottom"
                           v-validate="'required'"
                           v-model="ownerQuestions.validVehicleInspection">
                  </label>
                </div>

              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="m-t">
                Le kilométrage est-il inchangé ?
                &nbsp;<i class="fa fa-info-circle"
                         v-tooltip="{
                              content: 'Il doit avoir évolué de moins de 1500km depuis la dernière mise à jour de l\'annonce du véhicule',
                              placement: 'top-center',
                              classes: ['tooltip-white']
                            }"></i>
                <div class="pull-right response">
                  <div class="i-checks">
                    <label>
                      <input type="radio"
                             :value="true"
                             v-model="ownerQuestions.isKilometersUnChanged"> <i></i> Oui
                    </label>
                  </div>
                  <div class="i-checks m-l">
                    <label>
                      <input type="radio"
                             :value="false"
                             v-model="ownerQuestions.isKilometersUnChanged"> <i></i> Non
                    </label>
                  </div>
                </div>
                <div v-if="!ownerQuestions.isKilometersUnChanged"
                     class="form-group"
                     :class="{'has-error': errors.has('kilometers_changes')}">
                  <label class="control-label">
                    <input type="number"
                           placeholder="Nouveau km"
                           name="kilometers_changes"
                           class="form-control input-bottom"
                           v-validate="'required'"
                           v-model="ownerQuestions.kilometersChanged">
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="m-t">
                La carte grise est-elle valide ?
                <a @click="fetchDocument('carRegistration')"><small>(voir la carte grise)</small></a>
                &nbsp;<i class="fa fa-info-circle"
                         v-tooltip="{
                              content: 'Un certificat d\'immaticulation non barré est nécessaire pour la vente d\'un véhicule d\'occasion',
                              placement: 'top-center',
                              classes: ['tooltip-white']
                            }"></i>
                <div class="pull-right response">
                  <div class="i-checks">
                    <label>
                      <input type="radio"
                             :value="true"
                             v-model="ownerQuestions.isValidGrayCard"> Oui
                    </label>
                  </div>
                  <div class="i-checks m-l">
                    <label>
                      <input type="radio"
                             :value="false"
                             v-model="ownerQuestions.isValidGrayCard"> Non
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-12">
        <button type="button"
                class="pull-left btn btn-w-m btn-primary"
                @click="$parent.toggleBlock(1)">Précédent</button>
        <button type="button"
                class="btn btn-w-m btn-primary pull-right"
                @click="onSubmit">J'ai contrôlé les informations</button>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'

  export default {
    props: {
      ownerInformation: {
        type: Object,
        required: true
      },
    },

    data: () => ({
      ownerQuestions: {}
    }),

    computed: {
      commandId () {
        return this.$route.params.id
      },

      ownerQuestionsMutation () {
        return gql`
          mutation {
            ownerInformation(orderId:"${this.commandId}",
            ownerQuestions: {
              isValidGrayCard: ${this.ownerQuestions.isValidGrayCard},
              isStateUnchanged: ${this.ownerQuestions.isStateUnchanged},
              isKilometersUnChanged: ${this.ownerQuestions.isKilometersUnChanged},
              isValidVehicleInspection: ${this.ownerQuestions.isValidVehicleInspection},
              validGrayCard: "${this.ownerQuestions.validGrayCard}",
              stateUnchanged: "${this.ownerQuestions.stateUnchanged}",
              kilometersChanged: "${this.ownerQuestions.kilometersChanged}",
              validVehicleInspection: "${this.ownerQuestions.validVehicleInspection}",
            }
            ) {
              owners {
                id
                status
                result
              }
              ownerQuestions {
                id
                status
                result
              }
            }
          }`
      }
    },

    mounted () {
      this.ownerQuestions = this.ownerInformation.ownerQuestions
    },

    methods: {
      getDocumentId (type) {
        const query = gql`
          query {
            projectDocument(orderId: ${this.$parent.commandId}) {
              ${type} {
                id
              }
            }
          }`

        return this.$apollo.query({
          query: query
        })
      },

      getBase64Document (id) {
        const query = gql`
          query {
            showDocument(
            files: {
              fileId: ${id}
            })
            {
              files {
                base64
                id
              }
            }
          }`

        return this.$apollo.query({
          query: query
        })
      },

      async fetchDocument (type) {
        try {
          let response = await this.getDocumentId(type)
          const documentId = response.data.projectDocument[0][type].id
          if (!documentId) {
            throw 'no_document_id'
          } else {
            response = await this.getBase64Document(documentId)
            this.showFileViewer({
              image: response.data.showDocument.files[0].base64
            })
          }
        } catch (e) {
          this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.')
        }
      },

      async onSubmit () {

        let result = await this.$validator.validateAll()

        if (result) {
          this.$apollo.mutate({
            mutation: this.ownerQuestionsMutation
          }).then(() => {
            this.showBanner('success', 'Les informations ont bien été modifiées.')
            this.$parent.toggleBlock(3)
          })
        }
      }
    }
  }
</script>
